module.exports = __webpack_public_path__ + "static/media/link-playlist.10934fc2.svg";